import React from 'react';
import { Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BaseModalTitle from '@monorepo/shared/src/components/common/Modals/BaseModalTitle';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import ButtonWithFontAwesome from '@monorepo/shared/src/components/common/Buttons/ButtonWithFontAwesome';
import useAssignments from 'state/hooks/use-assignments';
import SaveEditAssignmentModal from './SaveEditAssignmentModal';

const tAssignment = (key, options?) => translate('assignment', key, options);

const EditAssignmentFooter: React.FC = () => {
  const classes = useStyles();
  const [
    { hasUnsavedChanges, selectedGroups },
    { handleExit, handleEditSave, deduplicateStudentsAndGroups },
  ] = useAssignments();
  const [, { openModal, closeModal }] = useModal();

  const handleSave = () => {
    const studentIds = deduplicateStudentsAndGroups();
    const isUnassigningLetter = !studentIds?.length && !selectedGroups?.length;

    const headerText = isUnassigningLetter
      ? tAssignment('unassignLetter')
      : tAssignment('saveChangesHeader');

    const rightButtonText = isUnassigningLetter
      ? tAssignment('unassignLetter')
      : tAssignment('saveChanges');

    openModal({
      Title: () => <BaseModalTitle text={tAssignment('saveChanges')} onClose={closeModal} />,
      body: (
        <SaveEditAssignmentModal
          closeModal={closeModal}
          handleEditSave={handleEditSave}
          headerText={headerText}
          isUnassigningLetter={isUnassigningLetter}
          rightButtonClass={classes.redButton}
          rightButtonText={rightButtonText}
        />
      ),
    });
  };

  return (
    <Paper className={classes.container}>
      <ButtonWithFontAwesome
        className={classes.button}
        onClick={handleExit}
        text={tAssignment('cancel')}
        aria-label={tAssignment('cancel')}
        variant="outlined"
        color="primary"
      />
      <ButtonWithFontAwesome
        className={classes.button}
        onClick={handleSave}
        text={tAssignment('saveChanges')}
        aria-label={tAssignment('saveChanges')}
        variant="contained"
        color="primary"
        disabled={!hasUnsavedChanges}
      />
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    height: 60,
    position: 'fixed',
    left: 0,
    bottom: 0,
    right: 0,
  },
  button: {
    margin: '10px 30px',
  },
  redButton: {
    backgroundColor: 'red',
  },
}));
export default EditAssignmentFooter;
